<div class="card mb-3">
  <ng-content></ng-content>
</div>
